export default __webpack_public_path__ + "static/media/hht2_storybook_11.9026594f.png";